import { render, staticRenderFns } from "./UserData.vue?vue&type=template&id=7d488728&scoped=true&"
import script from "./UserData.vue?vue&type=script&lang=js&"
export * from "./UserData.vue?vue&type=script&lang=js&"
import style0 from "./UserData.vue?vue&type=style&index=0&id=7d488728&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d488728",
  null
  
)

export default component.exports